import { gql } from '@apollo/client'
import { ObservationFragment } from '../fragments'

export const MUTATION_CREATE_OBSERVATION = gql`
  mutation createObservation($input: ObservationCreateInput!) {
    createObservation(input: $input) {
      ...ObservationFragment
    }
  }
  ${ObservationFragment}
`

export const MUTATION_UPDATE_OBSERVATION = gql`
  mutation updateObservation($input: ObservationUpdateInput!) {
    updateObservation(input: $input) {
      ...ObservationFragment
    }
  }
  ${ObservationFragment}
`

export const MUTATION_UPDATE_OBSERVATION_STATUS = gql`
  mutation updateObservationStatus($input: ObservationStatusUpdateInput!) {
    updateObservationStatus(input: $input) {
      ...ObservationFragment
    }
  }
  ${ObservationFragment}
`

export const MUTATION_DELETE_OBSERVATION = gql`
  mutation deleteObservation($id: ID!) {
    deleteObservation(id: $id)
  }
`

export const MUTATION_UPDATE_OBSERVATION_POSITIONS = gql`
  mutation updateObservationPositions($input: ObservationPositionsUpdateInput!) {
    updateObservationPositions(input: $input) {
      ...ObservationFragment
    }
  }
  ${ObservationFragment}
`
